import React, { useRef, useEffect } from "react";
import axios from "axios";
import "./ShakaSolutionViewVideoPlayer.scss";

import "shaka-player/dist/controls.css";
const shaka = require("shaka-player/dist/shaka-player.ui.js");

// Creating functional component
const ShakaSolutionViewVideoPlayer = ({ id_video }) => {
  const videoComponent = useRef(null);
  const videoContainer = useRef(null);

  const onErrorEvent = (event) => {
    onError(event.detail);
  };

  const onError = (error) => {
    console.error("Error code", error.code, "object", error);
  };

  useEffect(() => {
    const bodyFormData = new FormData();
    bodyFormData.append("flag", "1");
    bodyFormData.append("name", id_video);

    const axiosConfig = {
      headers: {
        accessKey: "NUIzQVhZRDFGUkhFOU44UTcwTDI=",
        secretKey: "NS80OFJ5RUl0dz1CbE5VNmczYVRvTVN4dnVLY1haWW43MkhiVnJlVw==",
        "user-id": "TESTing_10000903_97",
        "device-type": "1",
        "device-id": "71d3548555586126ed7071102e663619",
        version: "2",
        "device-name": "ChromeCDM",
        "account-id": "10000903",
      },
    };

    axios
      .post(
        "https://api.videocrypt.com/getVideoDetailsDrm",
        bodyFormData,
        axiosConfig
      )
      .then((result) => {
        const manifestUri = result?.data?.data?.link?.file_url;
        const licenseServer = "https://license.videocrypt.com/validateLicense";
        const token = result?.data?.data?.link?.token;

        const player = new shaka.Player(videoComponent.current);
        player.configure({
          drm: {
            servers: {
              "com.widevine.alpha":
                licenseServer + "?pallycon-customdata-v2=" + token,
            },
          },
        });

        const ui = new shaka.ui.Overlay(
          player,
          videoContainer.current,
          videoComponent.current
        );
        const config = {
          // overflowMenuButtons: ["quality"],
          // controlPanelElements: [
          //   "play-pause",
          //   "rewind",
          //   "fast-forward",
          //   "space",
          //   "play-back",
          // ],
        };
        ui.configure(config);
        ui.getControls();

        player.addEventListener("error", onErrorEvent);

        player
          .load(manifestUri)
          .then(() => {
            console.log("The video has now been loaded!");
            videoComponent.current.addEventListener("loadedmetadata", () => {
              videoComponent.current.play();
            });
          })
          .catch(onError);
      });
  }, [id_video]);

  return (
    <div className="video-container" ref={videoContainer}>
      <video className="shaka-video" ref={videoComponent} playsInline />
    </div>
  );
};

export default ShakaSolutionViewVideoPlayer;
